/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';
import Icon from '../../Icon';

/**
 * @deprecated since version 20.2.0. Please use the new Glyph component. You can read more about it in the prisma-design-system storybook under iconography/glyphs.
 */
const ArrowRightTail: any = ({ color, size = 'medium', ...props }) => {
  return (
    // @ts-expect-error TODO: Fix viewBox type in next ticket OF2-3365
    <Icon viewBox="0 0 28 28" size={size} color={color} {...props}>
      <path
        d="M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z"
        fillRule="evenodd"
      />
    </Icon>
  );
};

export default ArrowRightTail;

ArrowRightTail.propTypes = {
  color: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
};
